/**
 * Registers the service worker that backs PWA installability.
 *
 * Registration failures are logged and swallowed: the portal is fully functional
 * without a service worker, so a failure here must never break app startup.
 */
export function registerServiceWorker(): void {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
        return;
    }

    const register = () => {
        navigator.serviceWorker
            .register("/sw.js", { scope: "/", updateViaCache: "none" })
            .catch((error) => {
                console.error("Service worker registration failed:", error);
            });
    };

    if (document.readyState === "complete") {
        register();
    } else {
        window.addEventListener("load", register, { once: true });
    }
}
